export default "__VITE_ASSET__DeQTb9CT__"